import React, { useState } from 'react';

export const Examples = () => {
  const [activeTab, setActiveTab] = useState('basic');

  const [expandedImage, setExpandedImage] = useState(null);

  return (
    <section id="examples" className="examples">
      <div className="container">
        {/* ... existing header ... */}
        <div className="section-header">
          <h2>Real Examples</h2>
          <p>Copy, paste, and start sending</p>
        </div>

        {/* ... existing tabs ... */}
        <div className="examples-tabs">
          <button
            className={`tab-btn ${activeTab === 'basic' ? 'active' : ''}`}
            onClick={() => setActiveTab('basic')}
          >
            Basic
          </button>
          <button
            className={`tab-btn ${activeTab === 'template' ? 'active' : ''}`}
            onClick={() => setActiveTab('template')}
          >
            Template
          </button>
          <button
            className={`tab-btn ${activeTab === 'attachments' ? 'active' : ''}`}
            onClick={() => setActiveTab('attachments')}
          >
            Attachments
          </button>
        </div>

        <div className="examples-content">
          {/* ... basic panel ... */}
          <div className={`example-panel ${activeTab === 'basic' ? 'active' : ''}`}>
            <pre><code>
              <span className="comment">// Simple email with HTML body</span>{'\n'}
              <span className="keyword">LSend</span>.<span className="method">emails</span>(){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">sender</span>(<span className="string">'Support &lt;support@company.com&gt;'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">to</span>(<span className="string">'customer@example.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">cc</span>(<span className="string">'manager@company.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">subject</span>(<span className="string">'Your ticket has been received'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">html</span>(<span className="string">'&lt;p&gt;We will respond within 24 hours.&lt;/p&gt;'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">send</span>();
            </code></pre>
          </div>

          <div className={`example-panel ${activeTab === 'template' ? 'active' : ''}`}>
            <pre><code>
              <span className="comment">// Using Static Resource HTML template</span>{'\n'}
              <span className="keyword">LSend</span>.<span className="method">emails</span>(){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">sender</span>(<span className="string">'noreply@company.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">to</span>(<span className="string">'user@example.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">subject</span>(<span className="string">'Welcome to Our Platform!'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">staticResource</span>(<span className="string">'WelcomeEmail'</span>, <span className="keyword">new</span> <span className="type">Map</span>&lt;<span className="type">String</span>, <span className="type">String</span>&gt;{'{'}{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="string">'nome'</span> ={'>'} <span className="string">'João'</span>,{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="string">'empresa'</span> ={'>'} <span className="string">'Acme Inc'</span>,{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="string">'link_ativacao'</span> ={'>'} <span className="string">'https://app.exemplo.com/ativar'</span>{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;{'}'}){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">send</span>();
            </code></pre>
            <div className="example-visuals">
              <div className="visual-item" onClick={() => setExpandedImage('/images/template-raw.png')}>
                <span className="visual-label">Static Resource (Template)</span>
                <img src="/images/template-raw.png" alt="Raw Template" />
              </div>
              <div className="visual-arrow">→</div>
              <div className="visual-item" onClick={() => setExpandedImage('/images/template-final.png')}>
                <span className="visual-label">Result (Rendered)</span>
                <img src="/images/template-final.png" alt="Final Email" />
              </div>
            </div>
          </div>

          {/* ... attachments panel ... */}
          <div className={`example-panel ${activeTab === 'attachments' ? 'active' : ''}`}>
            <pre><code>
              <span className="comment">// Email with PDF attachment</span>{'\n'}
              <span className="type">Blob</span> pdfContent = <span className="type">PageReference</span>.getContent();{'\n\n'}

              <span className="keyword">LSend</span>.<span className="method">emails</span>(){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">sender</span>(<span className="string">'billing@company.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">to</span>(<span className="string">'customer@example.com'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">subject</span>(<span className="string">'Your Invoice #12345'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">html</span>(<span className="string">'&lt;p&gt;Please find your invoice attached.&lt;/p&gt;'</span>){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">attach</span>(<span className="string">'invoice.pdf'</span>, pdfContent){'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">attachContentVersions</span>(contentVersionIds) <span className="comment">// List&lt;Id&gt;</span>{'\n'}
              &nbsp;&nbsp;&nbsp;&nbsp;.<span className="method">send</span>();
            </code></pre>
          </div>
        </div>
      </div>

      {expandedImage && (
        <div className="lightbox-overlay" onClick={() => setExpandedImage(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setExpandedImage(null)}>×</button>
            <img src={expandedImage} alt="Expanded" />
          </div>
        </div>
      )}
    </section>
  );
};
